import { CommentsService } from './comments.service';
import { FeedService } from './feed.service';
var SocialContentService = /** @class */ (function () {
    function SocialContentService(token, groupId, contextTokenRepository) {
        this.feed = new FeedService(token, groupId, contextTokenRepository);
        this.comments = new CommentsService(token, groupId, contextTokenRepository);
    }
    return SocialContentService;
}());
export { SocialContentService };
//# sourceMappingURL=social-content.service.js.map